import * as actions from '../actions/actionConstants.js';

const initialState = {
  sendMessageStatus: '',
  error: ''
};

const smsReducer = (state = initialState, action) => {
	switch(action.type){
		case actions.SEND_MESSAGE:
			return{
				...state,
				sendMessageStatus: 'Sending'
			};
		case actions.SEND_MESSAGE_SUCCESS:
			return{
				...state,
				sendMessageStatus: 'Sent'
			};
		case actions.SEND_MESSAGE_ERROR:
			return{
				...state,
				error: action.error,
				sendMessageStatus: 'Error'
			};
		default:
			return state;
	}
};

export default smsReducer;



// WEBPACK FOOTER //
// ./src/reducers/sms.js